export default {
    data() {
        return {
            // key => boolean; true means show tooltip (content overflows)
            showTooltipMap: {},
        };
    },
    methods: {
        updateOverflowTooltip(event, key, options = {}) {
            const el = options.el || (event && (event.currentTarget || event.target)) || null;

            const target =
                options.targetSelector && el && el.querySelector ? el.querySelector(options.targetSelector) : el;

            const isOverflow = !!(target && target.scrollWidth > target.clientWidth);

            if (this.showTooltipMap && this.showTooltipMap[key] === isOverflow) return;
            this.$set(this.showTooltipMap, key, isOverflow);
        },
        hideOverflowTooltip(key) {
            if (this.showTooltipMap && this.showTooltipMap[key] === false) return;
            this.$set(this.showTooltipMap, key, false);
        },
    },
};
